import EventMarker from './EventMarker';

export default EventMarker;
